import { render, staticRenderFns } from "./TodoLeftSidebar.vue?vue&type=template&id=dbec2ffa"
import script from "./TodoLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TodoLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./TodoLeftSidebar.vue?vue&type=style&index=0&id=dbec2ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports